/**
 * Test IDs for QA automation.
 */
export const testIds = {
  conditionFormBillingRuleTarget: "condition-form-billing-rule-target",
  conditionFormBillingRuleTargetOption: "condition-form-billing-rule-target-option",
  conditionFormSupplierContractTarget: "condition-form-supplier-contract-target",
  conditionFormSupplierContractTargetOption: "condition-form-supplier-contract-target-option",
  conditionFormOperator: "condition-form-operator",
  conditionFormOperatorOption: "condition-form-operator-option",
} as const;
